export const assessments = {
  verifiers: "Vérificateurs",
  favorite_assessments: "Évaluations favorites",
  creation: {
    assessment_created: "L'évaluation a été créée avec succès.",
    assessment_is_being_created:
      "Votre évaluation est en cours de création. Veuillez patienter pendant que nous finalisons le processus.",
    confirmation_modal: {
      title_with_warnings: "Certains sites n'hériteront pas de données",
      title_without_warnings: "Créer une évaluation",
      description_with_warnings:
        "Vous avez sélectionné une évaluation précédente comme point de départ, mais les sites n'hériteront pas de toutes les données car il vous manque certains standards.",
      sites_warning_subtitle: "Les sites suivants hériteront de données partielles de l'évaluation précédente :",
      continue_confirmation: "Voulez-vous continuer à créer l'évaluation quand même ?",
      create_anyway: "Créer quand même",
    },
  },
  verification: {
    verification_cannot_be_undone: "Une fois vérifiée, cette action ne peut pas être annulée",
    assessment_verification: "Vérification de l'évaluation",
    verifies_this_assessment_on_behalf_of: "vérifie cette évaluation au nom de :",
    verified_this_assessment: "a vérifié cette évaluation",
    verifies_this_assessment: "vérifie cette évaluation",
    date_of_verification: "Date à laquelle la vérification a été effectuée",
    please_enter_verifier: "Veuillez saisir le vérificateur",
    send_verification: "Envoyer la vérification",
    verifier: "Vérificateur",
  },
  approval: {
    date_of_approval: "Date de l'approbation",
  },
  related_questions: "Questions connexes",
  data_providers_assign: {
    override_warning: "Les assignations de fournisseurs de données existantes seront remplacées.",
    data_provider_overview: "Aperçu des fournisseurs de données",
  },
  complete_assessment: {
    action: "Finaliser l'évaluation",
    confirm_completion: "Confirmer la finalisation de l'évaluation",
    upload_additional_files_to_sites: "Télécharger des fichiers supplémentaires vers les sites",
    upload_file_here: "Veuillez télécharger un fichier ici pour confirmer la finalisation de l'évaluation.",
    files_assigned_to_whole_assessment: "Fichiers assignés à l'ensemble de l'évaluation",
    i_am_aware_that_i_cannot_undo_this_action:
      "Je suis conscient(e) qu'une fois que je décide de finaliser l'évaluation, cette action ne peut pas être annulée. Ce processus est irréversible.",
    assessment_completion_confirmation:
      "L'évaluation a été finalisée avec succès. Vous pouvez la retrouver sous l'onglet 'Évaluation terminée'.",
  },
  previous_assessment: {
    label: "Évaluation précédente (facultatif)",
    description:
      "Vous pouvez sélectionner une évaluation précédente comme point de départ pour votre nouvelle évaluation. Les sites de l'évaluation sélectionnée seront mis en évidence avec une icône dans la liste déroulante ci-dessous, et toutes les données applicables seront copiées dans votre nouvelle évaluation. <a>En savoir plus</a>",
  },
  starting_point: "Point de départ de l'évaluation",
  reviewers_overview: "Aperçu des réviseurs",
  back_to_overview: "Retour à l'aperçu",
  site_assessment_progress: "Progression de l'évaluation du site",
  Active_assessments: "Évaluations actives",
  Completed_assessments: "Évaluations terminées",
  add_a_comment: "Ajouter un commentaire",
  Add_evidence: "Ajouter une preuve",
  Add_external_verification: "Ajouter une étape de vérification externe",
  Add_Step: "Ajouter une étape de révision",
  approval_cannot_be_undone: "Une fois approuvée, cette action ne peut pas être annulée",
  "After_approval,_You_can't_undo_approval": "Après approbation, vous ne pouvez pas annuler l'approbation.",
  All_assessments: "Toutes les évaluations",
  All_Sites: "Tous les sites",
  all_sites_description:
    "Toute modification que vous apportez à la sélection de standards ici sera appliquée à tous les sites que vous avez sélectionnés pour cette évaluation.",
  Applicability: "Applicabilité",
  Approve: "Approuver",
  approved_this_assessment: "a approuvé cette évaluation",
  Approver: "Approbateur",
  approves_this_assessment: "approuve cette évaluation",
  approves_this_assessment_on_behalf_of: "approuve cette évaluation au nom de :",
  archive_assessment_confirmation:
    "Êtes-vous sûr ? Une fois supprimée, cette évaluation et toutes les données associées, y compris les rapports, ne seront plus accessibles.",
  areas_of_improvement: "Axes d'amélioration",
  Assessment_approval: "Approbation de l'évaluation",
  Assessment_comment_overview: "Aperçu des commentaires de l'évaluation",
  Assessment_list: "Liste des évaluations",
  assessment_name: "Nom de l'évaluation",
  assessment_of_conformity: "Évaluation de conformité",
  Assessment_report: "Rapport d'évaluation",
  Assessment_standard_setup: "Configuration des standards d'évaluation",
  Assessment_update: "Mise à jour de l'évaluation",
  assessmentDetails: "Détails de l'évaluation",
  Assessments: "Évaluations",
  assign_data_providers: "Assigner les fournisseurs de données",
  Assign_data_providers_to_selected_themes: "Assigner des fournisseurs de données aux thèmes sélectionnés",
  assign_reviewers: {
    "After_confirmation,_this_assigment_will_be_deleted": "Après confirmation, cette assignation sera supprimée.",
    After_you_confirm_the_section:
      "Vous pouvez assigner des réviseurs et des groupes de réviseurs à des thèmes individuels pour chaque étape de révision de votre évaluation.",
    Assign_Reviewers: "Assigner des réviseurs",
    Assign_Reviewers_to_the_Theme: "Assigner des réviseurs au(x) thème(s) sélectionné(s)",
    Assign_to_selected: "Assigner aux sélectionnés",
    Assign_Verifiers: "Assigner des vérificateurs",
    Assign_Verifiers_to_an_assessment: "Assigner des vérificateurs à une évaluation",
    Assigned_Themes: "Thèmes assignés",
    Delete_assigment: "Supprimer l'assignation",
    Select_Reviewer_for_each_theme: "Assigner des réviseurs pour chaque thème ou groupe de thèmes",
    Selected_Theme: "Thème sélectionné",
    Step_stepNumber_External_Verification: "Étape {{stepNumber}} : Vérification externe",
    There_are_no_assigned_themes: "Il n'y a aucun thème assigné.",
    There_are_no_unassigned_themes: "Il n'y a aucun thème non assigné.",
    Unassigned_Themes: "Thèmes non assignés",
    Use_this_window_to_assign_multiply_reviewers_to_selected_themes:
      "Utilisez cette fenêtre pour assigner des réviseur(s) au(x) thème(s) sélectionné(s).",
    Verifiers: "Vérificateurs",
    View_assessment: "Voir l'évaluation",
  },
  assign_themes_description:
    "Après avoir assigné les thèmes, les fournisseurs de données seront chargés de remplir les réponses d'évaluation pour leur(s) thème(s) assigné(s). Tous les thèmes n'ont pas besoin d'être assignés pour procéder, mais un thème doit être assigné pour que l'évaluation de ses exigences connexes puisse se dérouler.",
  assign_themes_header: "Assigner un fournisseur de données pour chaque thème",
  Assigned_Corporate_Coordinator: "Coordinateur d'entreprise assigné",
  assigned_themes: "Thèmes assignés",
  associated_requirements: "Exigences associées",
  click_to_select: "Cliquez pour sélectionner des fichiers depuis votre ordinateur ou glissez-déposez.",
  Closing_steps: "Étapes de clôture",
  Comment: "Commentaire",
  Comment_and_evidence: "Commentaire et preuve",
  comments: "Commentaires",
  Conformity_assessment: "Évaluation de conformité",
  conformity_description:
    "La conformité fait référence au respect d'une exigence, et peut nécessiter des preuves pour démontrer à la fois le processus et la mise en œuvre, selon l'attente énoncée.",
  Conformity_level: "Niveau de conformité",
  Conformity_level_description:
    "Le niveau de conformité mesure la conformité avec un standard en termes de performance et de qualité. Il est utilisé pour s'assurer que des critères spécifiques de qualité, de sécurité ou réglementaires sont respectés pour un produit, service ou processus.",
  copy_answer: {
    confirmation: "Copier ces données entraînera l'écrasement de toute donnée de brouillon existante.",
    Filter: "Filtrer",
    site: "Site",
    status: "Statut",
  },
  Copy_this: "Copier ceci",
  clarifying_notes: "Notes de clarification",
  Corporate_coordinator_assigned: "Coordinateur d'entreprise assigné à cette évaluation",
  corporate_guidance: "Orientation d'entreprise",
  Country: "Pays",
  Create_assessment: "Créer une évaluation",
  Critical: "Critique",
  Data_Provider_Assignment: "Assignation des fournisseurs de données",
  Data_providers: "Fournisseurs de données",
  Data_providers_overview: "Aperçu des fournisseurs de données",
  Default_View: "Vue par défaut",
  Delete_evidence: "Supprimer la preuve",
  Delete_evidence_confirmation_message: "Après confirmation, cette preuve sera supprimée de ce protocole.",
  delete_evidences_description: "Après confirmation, cette preuve sera supprimée de ce protocole.",
  Delete_requirement: "Supprimer l'exigence",
  Description: "Description",
  Due_date: "Date d'échéance",
  edit_assessment: "Modifier l'évaluation",
  Edited_by: "Modifié par",
  erm_mapping_note: "Note de cartographie ERM",
  Evidence_files: "Fichiers de preuve",
  evidences: "Preuves",
  External_Verification: "Vérification externe",
  External_verifiers_can_see_comments: "Les vérificateurs externes peuvent voir les commentaires.",
  External_verifiers_have_been_added_and_they_can_read_comments_made_from_this_point_forward:
    "Des vérificateurs externes ont été ajoutés et ils peuvent lire les commentaires faits à partir de ce moment.",
  File: "Fichier",
  File_upload_error: "Erreur de téléchargement de fichier",
  Fill_in_Assessment_Details: "Remplir les détails de l'évaluation",
  Filter_by_site: "Filtrer par site",
  Filter_by_status: "Filtrer par statut",
  Filters: "Filtres",
  ghost_question_warning:
    "Cette question n'est plus valide pour cette évaluation en raison de la récente mise à jour du protocole. Veuillez <docsLink>cliquer ici</docsLink> pour lire notre documentation et en savoir plus sur le protocole et sa mise à jour.",
  Go_back_to_assessments: "Retour aux évaluations",
  informative: "Informatif",
  internal_audit_awareness:
    "Je suis conscient(e) que le processus d'audit ou d'évaluation interne est lié aux exigences associées. *",
  Last_edited: "Dernière modification",
  make_change_protocol_confirm: "Êtes-vous sûr de vouloir publier les modifications ?",
  make_change_protocol_confirm_description:
    "Considérez laisser un commentaire pour fournir le contexte aux autres utilisateurs concernant les modifications que vous avez apportées.",
  Modify_responses: "Modifier les réponses",
  Needs_review: "Nécessite une révision",
  Next_to_review: "Suivant à réviser",
  No_assessments_match_the_search_criteria: "Aucune évaluation ne correspond aux critères de recherche.",
  no_assigned_themes: "Il n'y a aucun thème assigné.",
  No_data_provider_assigned: "Aucun fournisseur de données assigné",
  No_more_Protocol_Questions_to_review_at_the_moment: "Aucune autre question de protocole à réviser pour le moment.",
  no_reviewers_assigned: "Aucun réviseur assigné",
  no_reviewer_assignments: "Aucune assignation de réviseur à afficher",
  no_unassigned_themes: "Il n'y a aucun thème non assigné.",
  normative: "Normatif",
  Notice: "Avis",
  on_behalf_of: "au nom de :",
  Please_enter_a_comment: "Veuillez saisir un commentaire",
  Please_enter_the_approver: "Veuillez saisir l'approbateur",
  Please_select_at_least_one_standard:
    "Vous devez avoir au moins un standard pour chaque site sélectionné. Veuillez revenir en arrière et désélectionner un site si vous ne souhaitez pas l'évaluer.",
  Please_upload_a_file_here_to_confirm_approval_from_your_superior:
    "Veuillez télécharger un fichier ici pour confirmer l'approbation de votre supérieur",
  Previous: "Précédent",
  Publish_changes: "Publier les modifications",
  Question_status: "Statut de la question",
  Reference: "Référence",
  Reference_data: "Données de référence",
  release_drop: "Relâchez pour déposer les fichiers ici.",
  Report_link: "Lien du rapport",
  reset_default_all_description:
    "Toute modification que vous apportez à la sélection de standards ici sera appliquée à tous les sites que vous avez sélectionnés pour cette évaluation.",
  Review_steps: "Étapes de révision",
  Reviewed_by: "Révisé par",
  reviewer_assignment_not_available_as_no_assingments_made_yet:
    "L'aperçu des assignations de réviseurs n'est pas encore disponible car aucune assignation n'a été faite.",
  Reviewers: "Réviseurs",
  Role: "Rôle",
  Search_assessment_by_site_name_or_assessment_name: "Rechercher une évaluation par nom de site ou nom d'évaluation",
  Search_standard_by_name: "Rechercher un standard par nom",
  Select_data_providers: "Sélectionner les fournisseurs de données",
  self_assessment_rating: {
    does_not_meat: "Ne répond pas",
    fully_meets: "Répond entièrement",
    not_applicable: "Non applicable",
    partially_meets: "Répond partiellement",
    substantially_meets: "Répond substantiellement",
  },
  Self_assessment_steps: "Auto-évaluation - étapes",
  "Self-assessment": "Auto-évaluation",
  Send_Approval: "Envoyer l'approbation",
  Site: "Site",
  Site_coordinator: "Coordinateur de site",
  Site_coordinators: "Coordinateurs de site",
  Site_List: "Liste des sites",
  Site_name: "Nom du site",
  site_setup: "Configuration de {{siteName}}",
  Sites: "Sites",
  Staff_and_dates_setup: "Configuration du personnel et des dates",
  stakeholders_awareness:
    "Je suis conscient(e) que l'engagement des parties prenantes est requis pour mettre en œuvre les exigences associées. *",
  standard_guidance: "Orientation du standard",
  "Standards_not_included_in_this_assessment_will appear_grayed-out_To_view_other_standards":
    "Les standards non inclus dans cette évaluation apparaîtront grisés. Pour voir d'autres standards mappés à cette question de protocole, cliquez sur l'icône 'Voir'.",
  "Standards_not_included_in_this_assessment_will_appear_grayed-out":
    "Les standards non inclus dans cette évaluation apparaîtront grisés.",
  status: {
    all_questions: "Toutes les questions",
    answered: "Répondu",
    assigned_to_me: "Assigné à moi",
    declined: "Refusé",
    in_draft: "En brouillon",
    in_review: "En révision",
    not_answered: "Non répondu",
    reviewed: "Révisé",
    unassigned: "Non assigné",
  },
  Step: "Étape",
  Step_1_Data_Provider_Assignment: "Étape 1 : Assignation des fournisseurs de données",
  "Step_2_Self-assessment": "Étape 2 : Auto-évaluation",
  submit_for_review: "Soumettre pour révision",
  sumbit_protocol_confirm: "Soumettre la question de protocole pour révision",
  sumbit_protocol_confirm_description: "Après confirmation, cette question de protocole sera envoyée pour révision.",
  tasks_comparison: {
    areas_of_improvement: " Axes d'amélioration",
    assessment_of_conformity: "Évaluation de conformité",
    Back_to_the_assessment_list: "Retour à la liste des évaluations",
    Comparison_view: "Vue de comparaison",
    conformity_level: "Niveau de conformité",
    evidences: "Preuves",
    field_name: "Nom du champ",
  },
  taskstatus: {
    declined: "Cette question de protocole est refusée.",
    in_review: "Cette question de protocole a été soumise pour le prochain cycle de révision.",
    reviewed: "Cette question de protocole est révisée.",
    not_submitted_for_review: "Cette question de protocole n'a pas encore été soumise pour révision.",
    unassigned: "Cette Question de Protocole n'a pas encore été attribuée à qui que ce soit.",
  },
  The_standards_you_select_impact_the_themes:
    "Seuls les standards sélectionnés dans la configuration du site sont rendus disponibles pour personnalisation.",
  Themes_are_not_assigned_yet:
    "Les fournisseurs de données n'ont pas encore été assignés. Le coordinateur de site devrait assigner des fournisseurs de données pour chaque thème avant de procéder.",
  There_are_currently_no_questions_that_are_available_for_this_Site:
    "Il n'y a actuellement aucune question disponible pour ce site.",
  There_are_no_assessments: "Il n'y a aucune évaluation.",
  This_is_a_Critical_requirement:
    "Ceci est une exigence critique définie par le conseil d'administration d'IRMA pour obtenir tout niveau de réalisation dans le système IRMA.",
  This_is_data_provide_view: "Vue du fournisseur de données",
  This_is_review_view: "Vue du réviseur",
  Type_here_to_add_description: "Tapez ici pour ajouter une description",
  unassigned_themes: "Thèmes non assignés",
  update_assessment: "Mettre à jour l'évaluation",
  Upload_an_evidence: "Télécharger une preuve",
  Upload_evidence: "Télécharger une preuve",
  Verifiers: "Vérificateurs",
  Verifiers_have_access_to_comments_that_are_made_after_they_are_assigned:
    "Les vérificateurs ont accès aux commentaires qui sont faits après qu'ils soient assignés. Ils ne peuvent pas accéder aux commentaires faits avant l'assignation.",
  approved: "Approuvé",
  verified: "Vérifié",
  verify: "Vérifier",
  view_assessment: "Voir l'évaluation",
  View_conversation: "Voir la conversation",
  View_conversation_another_comments: "Voir la conversation (+{{another_comments}})",
  You_can_reorder_reviewers_using_drag_and_drop:
    "Vous pouvez réorganiser les réviseurs en utilisant le glisser-déposer",
  means_of_verification: "Moyens de vérification",
  evidence_examples: "Exemples de preuves",
  "You_can't_deselect_a_site": "Vous ne pouvez pas désélectionner un site.",
  "Your_changes_are_not_auto-saved_Click_the_Publish_Changes_button_to_save_and_publish_your_changes":
    "Vos modifications ne sont pas sauvegardées automatiquement. Cliquez sur le bouton 'Publier les modifications' pour sauvegarder et publier vos modifications.",
  "Your_standard_setup_cannot_be_updated_as_your_assessment_isn't_employing_the_latest_protocol_set":
    "Votre configuration standard ne peut pas être mise à jour car votre évaluation n'utilise pas le dernier ensemble de protocoles. Veuillez contacter l'équipe d'assistance ERM pour obtenir de l'aide.",
  theme_progress: {
    title: "Progression des thèmes",
    site_assessment_label: "Évaluation du site",
    all_site_assessments: "Toutes les évaluations de sites",
    no_data: "Aucune donnée de thème disponible",
    axis_labels: {
      themes: "Thèmes",
      task_count: "Nombre de tâches",
    },
    status: {
      unassigned: "Non attribué",
      in_draft_unanswered: "Brouillon non répondu",
      in_draft_answered: "Brouillon répondu",
      declined: "Refusé",
      in_review: "En révision",
      reviewed: "Révisé",
    },
  },
} as const;
